<div class="documentos-consulta-container">
  <div class="header">
    <div class="header-title">
      <h1>Documentos</h1>
      <p class="subtitle">Visualização de documentos da consulta</p>
    </div>
    <div class="header-actions">
      <span class="badge-count" *ngIf="!loading">{{ documentos.length }} documento(s)</span>
      <button class="btn btn-outline-secondary" (click)="voltar()">
        <i class="fa fa-arrow-left"></i> Voltar
      </button>
    </div>
  </div>

  <div class="content-card" *ngIf="!loading && documentos.length === 0">
    <p class="empty-message mb-0">Nenhum documento encontrado para esta consulta.</p>
  </div>

  <div class="content-card">
    <div class="table-responsive" *ngIf="!loading && documentos.length > 0">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th style="width: 60px;">#</th>
            <th>Tipo</th>
            <th>Nome</th>
            <th>Descrição</th>
            <th style="width: 140px;">Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let documento of documentos; let i = index">
            <td>{{ i + 1 }}</td>
            <td>
              <span class="tipo-chip">{{ documento.tipo }}</span>
            </td>
            <td>{{ documento.nome || '-' }}</td>
            <td>{{ documento.descricao || '-' }}</td>
            <td>
              <button type="button" class="btn btn-sm btn-open" (click)="abrirDocumento(documento)">
                <i class="fa fa-external-link"></i> Abrir
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="opened-files mt-3" *ngIf="arquivosAbertos.length > 0">
      <h6 class="opened-title mb-2">Arquivos abertos</h6>
      <ul class="opened-list mb-0">
        <li *ngFor="let arquivo of arquivosAbertos; let i = index">
          <span class="opened-index">{{ i + 1 }}.</span>
          <span class="opened-name">{{ arquivo.nome }}</span>
          <span class="opened-type">({{ arquivo.tipo }})</span>
          <a class="opened-link" [href]="arquivo.url" target="_blank" rel="noopener">abrir novamente</a>
        </li>
      </ul>
    </div>

    <div class="pdf-preview-section mt-4" *ngIf="!loading && documentos.length > 0">
      <h6 class="opened-title mb-3">Visualização em tela (PDF)</h6>

      <div class="pdf-card" *ngFor="let documento of documentos; let i = index">
        <div class="pdf-card-header">
          <div>
            <strong>{{ i + 1 }}. {{ documento.nome || 'Documento PDF' }}</strong>
            <span class="pdf-meta"> - {{ documento.tipo || 'Documento' }}</span>
          </div>
          <a class="opened-link" [href]="resolverUrlDocumento(documento.path)" target="_blank" rel="noopener">abrir em nova guia</a>
        </div>

        <iframe
          class="pdf-viewer"
          [src]="resolverUrlDocumentoSegura(documento.path)"
          loading="lazy"
          referrerpolicy="no-referrer">
        </iframe>
      </div>
    </div>
  </div>
</div>
